import { axiosJsonInstance } from "@/axios.instance";
import axios, { AxiosInstance } from "axios";
import { MetadataType, MetadataObjectType, Metadata } from "@/store/metadata/types";

interface MetadataApiRequest {
	objects: {
		objectId: number;
		objectTypeId: number;
	}[];
	metadataTypeId?: number | null;
}

interface CreateMetadataApiRequest {
	metadataTypeId: number;
	objectTypeId: number;
	objectId: number;
	data: string;
}

interface UpdateMetadataApiRequest {
	metadataId: number;
	data: string;
}

interface DeleteMetadataApiRequest {
	metadataId: number;
}

class MetadataApi {
	private axios: AxiosInstance;

	constructor() {
		this.axios = axiosJsonInstance;
	}

	public async getMetadataTypes(): Promise<MetadataType[]> {
		const { data } = await this.axios.get("/Metadata/Types");
		return data;
	}

	public async getObjectTypes(): Promise<MetadataObjectType[]> {
		const { data } = await this.axios.get("/Metadata/ObjectTypes");
		return data;
	}

	public async getMetadataForObjects(metadataRequest: MetadataApiRequest): Promise<Metadata[]> {
		let endpoint = "";

		if (metadataRequest.metadataTypeId == null) {
			endpoint = `/Metadata/ForObjects`;
		} else {
			endpoint = `/Metadata/ForObjects?metadataTypeId=${metadataRequest.metadataTypeId}`;
		}

		const { data } = await this.axios.post(endpoint, metadataRequest.objects);
		return data;
	}

	public async createMetadata(newMetadataRequest: CreateMetadataApiRequest): Promise<Metadata> {
		const { data } = await this.axios.post("/Metadata/Create", newMetadataRequest);
		return data;
	}

	public async deleteMetadata(deleteMetadataRequest: DeleteMetadataApiRequest): Promise<void> {
		await this.axios.delete(`/Metadata/Delete/${deleteMetadataRequest.metadataId}`);
	}
}

const metadataApi = new MetadataApi();
export default metadataApi;
